import { computeAverage } from '@/common/number';

const FONT_FAMILY = 'DINPro-Medium, PingFang SC';

export const layoutStyle = {
  color: ['#2F9EFF', '#49DAA4', '#FFBD3D'],
  grid: {
    top: 15,
    bottom: 5,
    right: 38,
    left: 35,
  },
};

export const tooltipStyle = {
  trigger: 'axis',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  textStyle: {
    color: '#303133',
  },
  borderColor: 'rgba(18,55,140,0.08)',
  borderWidth: 1,
  padding: 16,
};

export const legendStyle = {
  top: 0,
  data: [],
};

export const xAxisStyle = {
  type: 'category',
  data: [],
  axisPointer: {
    type: 'shadow',
  },
  axisLabel: {
    color: '#9CA6C0',
    fontFamily: FONT_FAMILY,
  },
  axisLine: {
    lineStyle: {
      color: '#DEE0E2',
      width: 2,
    },
  },
};

export const yAxisStyle = {
  type: 'value',
  axisLabel: {
    color: '#9CA6C0',
    formatter(params) {
      const { remainder, abbr } = computeAverage(params);
      return `${remainder}${abbr}`;
    },
    fontFamily: FONT_FAMILY,
  },
  axisLine: {
    show: false,
    lineStyle: {
      color: '#DEE0E2',
      width: 2,
    },
  },
  axisTick: {
    show: false,
  },
  splitLine: {
    lineStyle: {
      type: 'dashed',
      width: 2,
      color: '#EBEEF5',
    },
  },
};

export const seriesStyle = {
  itemStyle: {
    barBorderRadius: 20,
  },
  barWidth: 10,
};
